import { Injectable } from '@angular/core';
import { Approval, Equipment } from '@core/interfaces';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { ApprovalAndEquipment, ApprovalsEquipmentsApi } from './api/approvals-equipments-api.service';

interface ApprovalsEquipmentsResult {
  items: Approval[];
  totalCount: number;
  filtered: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ApprovalsEquipmentsService {

  constructor(private api: ApprovalsEquipmentsApi, private fuseProgressBarService: FuseProgressBarService) { }

  async loadData({ where, options }): Promise<ApprovalsEquipmentsResult> {
    this.fuseProgressBarService.show();

    return this.api
      .listApprovalsEquipments({
        orderBy: options.orderBy,
        limit: options.limit,
        offset: options.offset,
        where: where
      })
      .toPromise()
      .then((data) => {

        this.fuseProgressBarService.hide();

          return {
            items: data.items,
            totalCount: data.totalCount,
            filtered: Boolean(
              !!where.name_contains ||
              !!where.number_contains ||
              !!where.equipmentType_in ||
              !!where.location_in ||
              !!where.company_in ||
              this.verifyStatusFiltered(where))
          };
        }
      );
  }

  verifyStatusFiltered(where): boolean {
    if (where.status_in) {
      return !(where.status_in.includes('pending') && where.status_in.length === 1);
    }

    return true;
  }

  getApprovalAndEquipment({ approvalId, equipmentQrCode }): Promise<ApprovalAndEquipment> {
    return this.api.getApprovalAndEquipment({
      approvalId,
      equipmentQrCode
    });
  }

  searchEquipment(number): Promise<Equipment> {
    return this.api.searchEquipment({
      number_eq: number
    });
  }

}
